import { t } from "i18next";
import React, { useState } from "react";

import { QUESTION_ORDER } from "../../constants/constant";
import FeedbackForm from "./FeedbackForm";

const CustomerSurvey = (props) => {
  const { setModalBody } = props;

  const [questionIndex, setQuestionIndex] = useState(1);

  return (
    <div id="customerSurvey">
      <form className="p-4">
        {QUESTION_ORDER.OVERALL_EFFORT === questionIndex && (
          <h5 className="mb-3 text-center feedback-title">{t("satisfy_with_agent")}</h5>
        )}
        <FeedbackForm
          questionIndex={questionIndex}
          setQuestionIndex={setQuestionIndex}
          setModalBody={setModalBody}
        />
      </form>
    </div>
  );
};

export default CustomerSurvey;
